import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadImages } from '../../actions/image.actions';
import ImageList from '../../components/imageList.components';
import Header from '../../components/main.header.component';
import Modal from '../Modal';

class Flickr extends Component {
  componentDidMount() {
    window.scrollTo(0,0);
  }
  constructor(){
    super();
    this.state = {
      images: [],
      search : '',
      isOpen: false,
      url: '',
      imagesLoading: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  handleSubmit(evt) {
    this.setState({ imagesLoading: true });
    evt.preventDefault();
    let tags = this.state.search;
    this.props.loadImages(tags);

  }

  handleSearchInput(evt) {
    this.setState(
    {
      search: evt.target.value
    });
  }

  openModal (evt) {
    let url = evt.target.src;
    if(url){ // clicking the actual image opens the Modal, and not just Div padding
      this.setState({
        isOpen: true,
        url: url
      });
    }
  }

  closeModal (evt) {
    this.setState({
      isOpen: false,
      url: ''
    });
  }

  render() {
                console.log(this.props.images.length);
    return (
    <div className="flickr">
      <Header
        props={this.props}
      />
      <div className="shade-headline">
        API Image Search
      </div>
      <div className="flickr-text">
        This uses Flickr's public, search API to create a responsive image gallery.<br /><br />
        It searches based on the tags associated with each image.<br />
        You can enter multiple tags in the search, such as "White Horse".<br />
        <h2>Built with:</h2>
          <ul>
            <li>Node.js</li>
            <li>React.js</li>
            <li>Redux</li>
            <li>Webpack</li>
            <li>CSS3</li>
          </ul>
        <div id="flickr-link">
          <a href="https://github.com/cozpon/Upthere_" target="_blank" rel="noopener noreferrer">
            <h3>View it on Github <br /> </h3>
          </a>
        </div>
          Or feel free to test it out below! <br />
      </div>
      <div className="flickr-color">
        <div className="flickr-form">
          <form onSubmit={this.handleSubmit}>
            <div className="flickr-search">
              <input
                className="flickr-input"
                name="search"
                type="text"
                placeholder="What are you looking for?"
                autocomplete="off"
                defaultValue={this.state.search}
                onChange={this.handleSearchInput}
              />
              <button
                className="flickr-button"
                type="submit"
                onClick={this.handleSubmit}>
                Search
              </button>
            </div>
          </form>
        </div>
          {(this.state.imagesLoading && this.props.images.length === 0) && (
            <div id="loading">
              <p className="loading"><span>L</span><span>o</span><span>a</span><span>d</span><span>i</span><span>n</span><span>g</span></p>
            </div>
          )}
          <div onClick={this.openModal}>
          { this.props.images && (
            <ImageList images={this.props.images} />
          )}
          </div>

          <Modal
            show={this.state.isOpen}
            onClose={this.closeModal}
            className="Modal-Backdrop" >
              <img
                className="Modal-Image"
                src={this.state.url}
                alt="lol"
              />
          </Modal>
        </div>
     </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    images : state.imageList
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    loadImages: (tag) => {
      dispatch(loadImages(tag));
    }
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Flickr);